import styled from "styled-components";

import { View } from "shared/containers/View";

// TODO: Cleanup

export const ContentContainer = styled.div`
  background-color: #fff;
  border: 2px solid #e1e8ef;
  border-radius: 12px;
  opacity: 1;
  overflow: hidden;
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  &.is-error {
    background-color: #fff1f0;
    border-color: #ff4d4f;
  }

  &.is-over {
    background-color: #f0f7ff;
    border-color: #0066cc;
    box-shadow: 0 8px 24px rgba(0, 102, 204, 0.15);

    &::after {
      content: "";
      position: absolute;
      inset: 4px;
      border: 2px dashed #0066cc;
      border-radius: 10px;
      pointer-events: none;
      animation: pulse 1.5s ease-in-out infinite;
    }

    @keyframes pulse {
      0%,
      100% {
        opacity: 0.4;
      }
      50% {
        opacity: 0.8;
      }
    }
  }

  &.is-past {
    background-color: #f5f5f5;
    border-color: #d0d0d0;
    opacity: 0.7;

    &:hover {
      box-shadow: none;
    }
  }
`;

export const ContentContainerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background-color: #fff;
  border-left: 4px solid transparent;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #f8f9fa;
  }

  &.is-clickable {
    cursor: pointer;
  }

  &.is-current {
    background-color: #f0f7ff;
    border-left-color: #0066cc;

    &:hover {
      background-color: #e6f2ff;
    }
  }

  &.is-past {
    background-color: #ebebeb;
    border-left-color: #999999;

    &:hover {
      background-color: #ebebeb;
    }
  }
`;

export const ContentContainerHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const ContentContainerHeaderLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #1a2332;
`;

export const ActivityCount = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #8391a1;
`;

export const ContentDropZoneContainer = styled.div`
  box-sizing: border-box;
  min-height: 150px;
  padding: 24px;
  background-color: #fff;
  border-top: ${({ theme }) => theme.semantic.container.border};
  transition: background-color 0.2s ease;

  &.is-error {
    background-color: #fff1f0;
    border-color: #ff4d4f;
  }

  &.is-over {
    background-color: #e6f2ff;
    box-shadow: inset 0 0 0 2px #5096e8;
  }
`;

// TreatmentEditor styles

export const StyledView = styled(View)`
  .view-content-container {
    height: 100%;
    /* overflow: auto; */
  }
`;

export const Container = styled.div`
  display: flex;
  gap: 16px;
  height: 100%;
  /* overflow: hidden; */
`;

export const ProgramContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 16px;
  background-color: #fff;
  border-radius: 12px;
`;

export const DragPreviewCard = styled.div`
  opacity: 0.95;
  transform: rotate(2deg);
  cursor: grabbing;
`;

export const LoadMoreWeeksButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 32px;
  background-color: #ffffff;
  border: 2px dashed #c5d0dd;
  border-radius: 12px;
  color: #5c6f82;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #0066cc;
    color: #0066cc;
    background-color: #f0f7ff;
  }

  &:active {
    transform: scale(0.98);
  }
`;
